module.exports = fox._r("images/slides/urban/slide_2_6.jpg", __webpack_public_path__ + "images/slides/urban/slide_2_6.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_2_6.jpg
// module id = 59
// module chunks = 2